import { RateLimitError } from "@/lib/queryClient";
import { ApiFetchError } from "@/lib/apiFetch";

export interface RateLimitInfo {
  message: string;
  retryAfterSeconds: number | null;
}

function buildMessage(seconds: number | null): string {
  const wait = seconds
    ? ` Please wait ${seconds} second${seconds !== 1 ? "s" : ""} before trying again.`
    : " Please wait a moment before trying again.";
  return `You're submitting too quickly.${wait}`;
}

export function parseRateLimit(err: unknown): RateLimitInfo | null {
  if (err instanceof RateLimitError) {
    return { message: err.message, retryAfterSeconds: err.retryAfterSeconds };
  }
  if (err instanceof ApiFetchError && err.status === 429) {
    const body = err.body as { retryAfter?: unknown; retryAfterSeconds?: unknown } | undefined;
    const raw = body?.retryAfter ?? body?.retryAfterSeconds;
    const seconds = typeof raw === "number" && Number.isFinite(raw) ? raw : null;
    return { message: buildMessage(seconds), retryAfterSeconds: seconds };
  }
  return null;
}
